import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Button from 'atoms/button';
import Input from 'atoms/input';
import SelectButton from 'atoms/select-button';
import TipDefaultValues from 'organisms/Modals/TipDefaultValues';
import { setCustomTip, setTip } from 'store/reducers/checkout';

import TipModal from './TipModal';

export default function Tips() {
  const dispatch = useDispatch();
  const { customTip, selectedTip } = useSelector((state) => state.checkout);
  const [isCustomerInputModalOpen, openCustomerInputModal] = useState(false);
  const [isTipsModalOpen, openTipsModal] = useState(false);
  const { tips } = useSelector((state) => state.provider.locations[0]);
  const defaultTips = tips?.map(({ description, percent }) => ({
    value: description,
    id: percent,
  }));

  const onChangeDefaultTip = (tip) => {
    dispatch(setCustomTip(''));

    if (tip.id === selectedTip.id) {
      return dispatch(setTip({}));
    }

    dispatch(setTip(tip));
  };

  const onChangeCustomTip = (tip) => {
    dispatch(setTip({}));
    dispatch(setCustomTip(tip));
  };

  const onToggleTipsDefaultModal = (value) => {
    openTipsModal(value);
  };

  const toggleCustomerInput = () => {
    openCustomerInputModal(true);
  };

  return (
    <div className="mb-12 p-24 border-light-purple radius-24">
      <div className="flex-row justify-between mb-8">
        <h4>Tips</h4>
        <button
          onClick={() => onToggleTipsDefaultModal(true)}
          className="no-style-btn c-primary-orange fw-400 f12 pointer"
        >
          Customize
        </button>
      </div>
      <div className="flex-row w-100 justify-between">
        {defaultTips.map((tip) => (
          <SelectButton
            key={tip.id}
            size="small"
            onClick={onChangeDefaultTip}
            isActive={selectedTip.id === tip.id}
            value={tip}
          >
            {tip.value}
          </SelectButton>
        ))}
        <Input
          className="custom-tip-input"
          isMoney
          textAlignment="right"
          placeholder="0.00"
          variant="white"
          size="small"
          onChange={onChangeCustomTip}
          value={customTip}
        />
      </div>
      <Button
        text="Customer input"
        onClick={toggleCustomerInput}
        size="small"
        className="fw-400 mt-10 pointer"
        variant="white-outlined"
      />
      {isTipsModalOpen && (
        <TipDefaultValues
          onChangeDefaultTip={onChangeDefaultTip}
          defaultTips={defaultTips}
          isOpen={isTipsModalOpen}
          onRequestClose={onToggleTipsDefaultModal}
        />
      )}
      {isCustomerInputModalOpen && (
        <TipModal
          onSelectTip={onChangeDefaultTip}
          onSetCustomTip={onChangeCustomTip}
          defaultTips={defaultTips}
          isOpen={isCustomerInputModalOpen}
          toggleModal={openCustomerInputModal}
        />
      )}
    </div>
  );
}
